<script setup>
  const props = defineProps({
    model: {
      type: Object,
      required: true,
    },
    item: {
      type: Array
    }
  })

  const getCellClasses = (cell) => {
    return [
      cell.cssClass || '',
      {
        empty: !cell.value && !cell.link,
      },
    ]
  }

  const getColspan = (cell) => {
    return cell.colspan && cell.colspan > 0 ? cell.colspan : 1
  }

  const getRowspan = (cell) => {
    return cell.rowspan && cell.rowspan > 0 ? cell.rowspan : 1
  }

  const isHalfWidth = (index) => [1, 2, 7, 8].includes(index)
</script>

<template>
  <div class="technical-data">

    <div class="title" v-html="item.content"></div>

    <div class="tables-container">
      <div
        v-for="(table, tableIndex) in model"
        :key="tableIndex"
        :class="['table-wrapper', { 'half-width': isHalfWidth(tableIndex) }]">
        <table class="technical-table">
          <tbody>
          <tr
            v-for="(row, rowIndex) in table.rows"
            :key="rowIndex">
            <template
              v-for="(cell, cellIndex) in row.cells"
              :key="cellIndex">
              <template v-if="cell.colspan !== 0 && cell.rowspan !== 0">
                <td
                  :colspan="getColspan(cell)"
                  :rowspan="getRowspan(cell)"
                  :class="getCellClasses(cell)"
                  :style="{
                        color: cell.color || '',
                        backgroundColor: cell.backgroundColor || '',
                      }">
                  <img
                    v-if="cell.link && !cell.value"
                    :src="cell.link"
                    alt=""
                    class="cell-image">
                  <div
                    v-else
                    v-html="cell.value" />
                </td>
              </template>
            </template>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="container-legend">
      <div class="left">
        <p>* Requirement: declared value</p>
        <p>** Sizes in cm</p>
        <p>• Format or surface texture not produced by Topcer</p>
      </div>
      <div class="right">
        <p>Independent test reports available upon reques</p>
      </div>


    </div>
  </div>
</template>

<style scoped>
  .technical-data {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .title {
    font-family: "Bai Jamjuree", serif;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 24px;
  }


  .tables-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .table-wrapper {
    width: 100%;
    margin-bottom: 16px;
    box-sizing: border-box;
  }


  .table-wrapper.half-width {
    width: calc(50% - 8px);
  }

  .technical-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 13px;
    font-family: Arial, sans-serif;
  }

  .technical-table td {
    border: 1px solid #D0D0D0;
    padding: 10px;
    vertical-align: middle;
    text-align: center;
    word-break: break-word;
  }

  .technical-table tr:first-child td {
    background: #DEDEDE;
    font-weight: 700;
    border-right: 1px solid #D0D0D0;
    border-left: 1px solid #D0D0D0;
    text-align: start;
  }

  .technical-table img.cell-image {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .empty {
    background-color: #fff;
  }

  @media(max-width: 1284.5px) {
    .technical-table {
      min-width: 1200px;
      border: 1px solid #ddd;
    }
  }

  @media (max-width: 768px) {
    .table-wrapper.half-width {
      width: 100%;
    }

    .technical-table {
      font-size: 11px;
      min-width: 800px;
    }

    .technical-table td {
      padding: 6px;
    }
  }
  .container-legend{
    padding-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 30px;
    .left{
      p{
        margin-bottom: 0;
        font-family: "Bai Jamjuree", serif;
      }
    }
    .right{
      p{
        margin-bottom: 0;
        font-family: "Bai Jamjuree", serif;
      }
    }
  }
</style>
